import { WebAlertRepository } from '../infrastructure/WebAlertRepository';
import { WebAlertStatistics } from '../domain/WebAlertStatistics';

export class WebAlertService {
    constructor(host, region) {
        this.repository = new WebAlertRepository(host, region);
    }

    async getStatistics(startDate, endDate) {
        try {
            const endpoints = [
                { name: 'alert', api: 'getline_alert_statistics', field: 'count', dateField: 'date' },
                { name: 'booking', api: 'getlinebindstatistics_booking', field: 'booking', dateField: 'statisticsdate' },
                { name: 'cargps', api: 'getlinebindstatistics_cargps', field: 'cargps', dateField: 'statisticsdate' },
                { name: 'dirorder', api: 'getlinebindstatistics_dirorder', field: 'dirorder', dateField: 'statisticsdate' }
            ];

            const results = await Promise.all(
                endpoints.map(({ api }) =>
                    this.repository.fetchStatistics(api, startDate, endDate)
                )
            );

            // 合併所有統計數據
            const mergedData = WebAlertService.mergeStatisticsData(results, endpoints);
            return mergedData.map(data => new WebAlertStatistics(data));
        } catch (error) {
            console.error('Error in WebAlertService.getStatistics:', error);
            throw error;
        }
    }

    static mergeStatisticsData(results, endpoints) {
        const dateMap = new Map();

        results.forEach((result, index) => {
            result.forEach((item) => {
                const date = item[endpoints[index].dateField]; // 使用對應的日期欄位
                if (!dateMap.has(date)) {
                    dateMap.set(date, { statisticsdate: date });
                }
                const currentData = dateMap.get(date);

                const value = item[endpoints[index].field];
                currentData[endpoints[index].field] = value != null ? String(value) : '0';
            });
        });

        return Array.from(dateMap.values());
    }
}
